
import React from 'react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';

import metadata from './MLClaimDetailsVehicles.metadata.json5';
import messages from './MLClaimDetailsVehicles.messages';

function MLClaimDetailsVehicles(props) {
    const {
        className,
        insuredVehicleIncident,
        thirdPartyVehicleIncidents
    } = props;
    const translator = useTranslator();

    const getYearMakeModel = (object) => {
        const vehicle = object?.vehicle;
        if (vehicle?.make) {
            return `${vehicle.year}/${vehicle.make}/${vehicle.model}`;
        }
        return <>{translator(messages.NamedNonOwner)}</>;
    };

    const generateOverrides = () => {
        const vehicleDetailsOverride = thirdPartyVehicleIncidents.map((thirdPartyVehicleIncident, index) => {
            return {
                [`thirdPartyVehicleIncidentsColYearMakeModel${index}`]: {
                    content: getYearMakeModel(thirdPartyVehicleIncident)
                },
                [`thirdPartyVehicleIncidentsColVin${index}`]: {
                    visible: !!thirdPartyVehicleIncidents?.vehicle?.vin,
                    content: <>{`${translator(messages.vin)} ${thirdPartyVehicleIncidents?.vehicle?.vin}`}</>
                },
            };
        });

        return Object.assign({}, ...vehicleDetailsOverride);
    };

    const overrides = {
        VehiclesComponent: {
            className
        },
        yourVehicleCol: {
            visible: !!insuredVehicleIncident
        },
        yourVehicle:{
            content: getYearMakeModel(insuredVehicleIncident)
        },
        yourVehicleVin: {
            visible: !!insuredVehicleIncident?.vehicle?.vin,
            content: <>{translator(messages.vin)}{insuredVehicleIncident?.vehicle?.vin}</>
        },
        thirdPartyVehicleIncidentsIterable: {
            data: thirdPartyVehicleIncidents || []
        },

        ...generateOverrides()
    };
    const resolvers = {
        resolveClassNameMap: {},
        resolveComponentMap: {
        },
        resolveCallbackMap: {
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

export default MLClaimDetailsVehicles;
